import React, { useEffect, useState } from "react";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { useConfigService } from "../../hooks";
import "./assets/style.css";

const UserGuideViewer: React.FC = () => {
    const { getUserGuidePdf } = useConfigService();
    const [isLoadingPdf, setisLoadingPdf] = useState<boolean>(true);
    const [pdfUrl, setPdfUrl] = useState<string>();

    useEffect(() => {
        document.title = "CARES - User guide";

        const fetchPdf = async () => {
            setisLoadingPdf(true);
            try {
                const response = await getUserGuidePdf();
                setPdfUrl(response);
                setisLoadingPdf(false)
            } catch (error) {
                console.error("Error fetching PDF:", error);
            }
        };

        fetchPdf();
    }, []);

    return (
        <div className="user-guide-viewer">
            {
                (isLoadingPdf && !pdfUrl) && (
                    <div className="loading-box">
                        <div className="msg-box">Loading the CARES - User Guide...</div>
                    </div>
                )
            }

            {
                (!isLoadingPdf && !pdfUrl) && (
                    <div className="loading-box">
                        <div className="msg-box">We had a problem loading the PDF. Try again later.</div>
                    </div>
                )
            }

            {
                (!isLoadingPdf && pdfUrl) && (
                    <div className="pdf-container">
                        <iframe
                            src={pdfUrl}
                            title="Cares User Guide"
                            width="100%"
                            height="100%"
                            style={{ border: 'none', overflow: 'hidden' }}
                            allowFullScreen
                        />
                    </div>
                )
            }
        </div>
    )
}

export { UserGuideViewer };
